import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/site";
import { useLang } from "@/lib/i18n";

export const InquiryForm = ({ propertyId = "", dark = false }) => {
  const { t, lang } = useLang();
  const [f, setF] = useState({ name: "", email: "", phone: "", message: "", consent: false });
  const [state, setState] = useState("idle");
  const set = (k) => (e) => setF((o) => ({ ...o, [k]: k === "consent" ? e.target.checked : e.target.value }));
  const submit = async (e) => {
    e.preventDefault();
    setState("sending");
    try {
      await api.post("/inquiries", { ...f, property_id: propertyId });
      setState("sent");
    } catch { setState("error"); }
  };
  const inp = `w-full bg-transparent border-b ${dark ? "border-ivory/25 text-ivory placeholder:text-ivory/55" : "border-midnight/20 text-midnight placeholder:text-midnight/50"} py-3 text-sm outline-none focus:border-gold transition-colors`;
  if (state === "sent") return <p data-testid="inquiry-success" className={`font-display text-2xl italic ${dark ? "text-ivory" : "text-midnight"}`}>{t.inquiry.sent}</p>;
  return (
    <form onSubmit={submit} className="space-y-5" data-testid="inquiry-form">
      <input required minLength={2} value={f.name} onChange={set("name")} placeholder={t.inquiry.name} className={inp} data-testid="inquiry-name" />
      <div className="grid sm:grid-cols-2 gap-5">
        <input required type="email" value={f.email} onChange={set("email")} placeholder={t.inquiry.email} className={inp} data-testid="inquiry-email" />
        <input value={f.phone} onChange={set("phone")} placeholder={t.inquiry.phone} className={inp} data-testid="inquiry-phone" />
      </div>
      <textarea rows={4} value={f.message} onChange={set("message")} placeholder={t.inquiry.message} className={`${inp} resize-none`} data-testid="inquiry-message" />
      <label className={`flex gap-3 items-start text-xs ${dark ? "text-ivory/75" : "text-midnight/70"}`}>
        <input required type="checkbox" checked={f.consent} onChange={set("consent")} className="mt-0.5 accent-[#C8A96B]" data-testid="inquiry-consent" />
        <span>{t.inquiry.consent} <Link to="/gdpr" className="text-gold underline underline-offset-2">{t.inquiry.gdpr}</Link>.</span>
      </label>
      {state === "error" && <p className="text-sm text-red-400" data-testid="inquiry-error">{t.inquiry.error}</p>}
      <button disabled={state === "sending"} className="btn-gold w-full h-14" data-testid="inquiry-submit">{state === "sending" ? "…" : t.inquiry.send}</button>
      <input type="hidden" value={lang} readOnly />
    </form>
  );
};
